import * as React from "react";
import Page from "@app/shared/Page";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import { ClientSelection } from "@app/access-reports/admin/template-update/ClientSelection";
import { NodeOverview } from "@app/access-reports/admin/template-update/NodeOverview";
import { TemplateNodeSelection } from "@app/access-reports/admin/template-update/TemplateNodeSelection";
import { TemplateUpdateContext, TemplateUpdateProvider } from "@app/access-reports/admin/template-update/TemplateUpdateContext";

const TemplateUpdateWithContext: React.FC<React.PropsWithChildren<unknown>> = () => {
  const clientDefaultContext = React.useContext(TemplateUpdateContext);

  return (
    <Page className="bg-white" documentTitle="Template Update">
      <PageInner>
        <PageSection>
          <div className="row">
            <div className="col-12">
              <h2 className="mt-3 mb-3 header-l demibold">
                Template Node Admin
              </h2>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <ClientSelection
                selectedClients={clientDefaultContext.selectedClients}
                setSelectedClients={clientDefaultContext.setSelectedClients}
              />
            </div>

            <div className="col-md-6">
              <TemplateNodeSelection
                selectedClients={clientDefaultContext.selectedClients}
                selectedNode={clientDefaultContext.selectedNode}
                selectedNodeType={clientDefaultContext.selectedNodeType}
                setSelectedNode={clientDefaultContext.setSelectedNode}
                setSelectedNodeType={clientDefaultContext.setSelectedNodeType}
                setTemplate={clientDefaultContext.setTemplate}
                template={clientDefaultContext.template}
              />
            </div>
          </div>

          <hr />

          {(clientDefaultContext.selectedClients.length > 0 && !!clientDefaultContext.selectedNode && !!clientDefaultContext.selectedNodeType) && (
            <NodeOverview
              selectedNode={clientDefaultContext.selectedNode}
              selectedNodeType={clientDefaultContext.selectedNodeType}
              setSelectedNode={clientDefaultContext.setSelectedNode}
              setTemplate={clientDefaultContext.setTemplate}
              template={clientDefaultContext.template}
            />
          )}
        </PageSection>
      </PageInner>
    </Page>
  );
}

export const TemplateUpdate: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <TemplateUpdateProvider>
      <TemplateUpdateWithContext />
    </TemplateUpdateProvider>
  );
}
